import intl from 'react-intl-universal';
import exportIcon from '../../../../assets/icons/export.svg';
import { DASHBOARD_DETAIL_ACTIONS } from '../../../../utils/constants/dashboard';
import { useExport } from './hooks/useExport';
import { useSelector } from 'react-redux';
import { RootState, useAppThunkDispatch } from '../../../../state/store';
import { chartDataSelectors } from '../../../../state/normalized/insights/chartDataSlice';
import {
  Icon,
  OverflowMenuItem,
  tailwindOverride,
  Typography,
} from '@getsynapse/design-system';
import { GridItemData } from './GridItem';
import { INSIGHT_TO_EXPORT_DATA_PARSER } from 'types/store/normalized/insights/InsightCatalogue';
import { BaseInsightPayload } from 'types/store/normalized/insights/InsightDataPayload';
import { useMemo } from 'react';
import { showNotification } from 'state/SnackbarNotification/SnackbarNotificationSlice';

export const ExportInsightDataOverflowMenu = (props: {
  gridItemData: GridItemData;
}) => {
  const { gridItemData } = props;

  const dispatch = useAppThunkDispatch();
  const chartData = useSelector((state: RootState) =>
    chartDataSelectors.selectChartDataById(state, gridItemData.insightId)
  );

  const { exportChartData } = useExport();

  const hasData = chartData && chartData.data;

  const dataParser = useMemo(() => {
    return INSIGHT_TO_EXPORT_DATA_PARSER[gridItemData.cardType.insightId];
  }, [gridItemData.cardType.insightId]);

  const item = {
    label: intl.get('DASHBOARD_DETAIL.ACTION.EXPORT_DATA'),
    iconSrc: exportIcon,
    onSelect: async () => {
      if (hasData) {
        try {
          const parsedChartData: BaseInsightPayload | undefined =
            dataParser && chartData ? dataParser(chartData) : chartData;
          if (parsedChartData) {
            await exportChartData(gridItemData.name, parsedChartData);
          }
        } catch (error) {
          dispatch(
            showNotification({
              notificationVariant: 'error',
              notificationTitle: intl.get('ERROR_SNACKBAR_TITLE'),
              notificationMessage: intl.get(
                'DASHBOARD_DETAIL_PAGE.FAILED_TO_EXPORT_DATA'
              ),
            })
          );
        }
      }
    },
    action: DASHBOARD_DETAIL_ACTIONS.EXPORT_DATA,
  };

  return hasData ? (
    <OverflowMenuItem
      key={item.label}
      disabled={!hasData}
      className='flex items-center space-x-2'
      onSelect={item.onSelect}
      data-cy={`insight-${gridItemData.cardTypeId}__actions-popover__${item.action}`}
    >
      <Icon
        src={item.iconSrc}
        className={tailwindOverride(
          'fill-current text-primary group-hover:fill-current group-hover:text-secondary-darker text-lg',
          {
            'text-xl': item.iconSrc,
          }
        )}
      />
      <Typography
        variant='label'
        className='group-hover:text-secondary-darker cursor-pointer'
      >
        {item.label}
      </Typography>
    </OverflowMenuItem>
  ) : (
    <></>
  );
};
